import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

function getRealNextPath(prevPath, nextPath) {
  var childrenProp = this.props.childrenProp;
  var ppLastIndex = prevPath.length - 1;
  var npLastIndex = nextPath.length - 1;

  if (prevPath.length < nextPath.length) {
    // move into deep
    var wasShifted = false;
    return nextPath.map(function (nextIndex, i) {
      if (wasShifted) {
        return i === npLastIndex ? nextIndex + 1 : nextIndex;
      }

      if (typeof prevPath[i] !== 'number') {
        return nextIndex;
      }

      if (nextPath[i] > prevPath[i] && i === ppLastIndex) {
        wasShifted = true;
        return nextIndex - 1;
      }

      return nextIndex;
    });
  }

  if (prevPath.length === nextPath.length) {
    // if move bottom + move to item with children => make it a first child instead of swap
    if (nextPath[npLastIndex] > prevPath[npLastIndex]) {
      var target = this.getItemByPath(nextPath);

      if (target[childrenProp] && target[childrenProp].length && !this.isCollapsed(target)) {
        return nextPath.slice(0, -1).concat(nextPath[npLastIndex] - 1).concat(0);
      }
    }
  }

  return nextPath;
}
function getPathById(id) {
  var _this = this;

  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getDefaultItems();
  var childrenProp = this.props.childrenProp;
  var path = [];
  items.every(function (item, i) {
    if (item.id === id) {
      path.push(i);
    } else if (item[childrenProp]) {
      var childrenPath = _this.getPathById(id, item[childrenProp]);

      if (childrenPath.length) {
        path = path.concat(i).concat(childrenPath);
      }
    }

    return path.length === 0;
  });
  return path;
}
function getItemByPath(path) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getDefaultItems();
  var childrenProp = this.props.childrenProp;
  var item = null;
  path.forEach(function (index) {
    var list = item ? item[childrenProp] : items;
    item = list[index];
  });
  return item;
}
function getItemDepth(item) {
  var childrenProp = this.props.childrenProp;
  var level = 1;

  if (item[childrenProp].length > 0) {
    var childrenDepths = item[childrenProp].map(this.getItemDepth);
    level += Math.max.apply(Math, _toConsumableArray(childrenDepths));
  }

  return level;
}
function getSplicePath(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var splicePath = {};
  var numToRemove = options.numToRemove || 0;
  var itemsToInsert = options.itemsToInsert || [];
  var lastIndex = path.length - 1;
  var currentPath = splicePath;
  path.forEach(function (index, i) {
    if (i === lastIndex) {
      currentPath.$splice = [[index, numToRemove].concat(_toConsumableArray(itemsToInsert))];
    } else {
      var nextPath = {};
      currentPath[index] = _defineProperty({}, options.childrenProp, nextPath);
      currentPath = nextPath;
    }
  });
  return splicePath;
}

export { getItemByPath, getItemDepth, getPathById, getRealNextPath, getSplicePath };
//# sourceMappingURL=paths.js.map
